import React from 'react';
import { useDarkMode } from '../../darkmode/DarkModeContext';

const Channel = () => {
  const { isDarkMode } = useDarkMode();

  const channelOptions = [ 
    {
      id: 'chatbot',
      name: 'Chatbot AI',
      icon: '/image/chatbot.png',
      description: 'Bantuan otomatis 24/7 dengan respon cepat',
      features: ['Respon instan', 'Tersedia 24/7', 'Solusi umum', 'Panduan step-by-step'],
      action: 'Mulai Chat',
      color: 'from-blue-900 to-blue-700',
      fallbackIcon: '🤖'
    },
    {
      id: 'whatsapp',
      name: 'WhatsApp Support',
      icon: '/image/whatsapp.png',
      description: 'Chat langsung dengan customer service melalui WhatsApp',
      features: ['Agent manusia', 'Chat personal', 'Dukungan kompleks', 'Follow-up mudah'],
      action: 'Buka WhatsApp',
      color: 'from-green-500 to-green-600',
      fallbackIcon: '📱'
    }
  ];

  const handleChannelSelect = (channel) => {
    if (channel.id === 'chatbot') {
      // Redirect ke halaman chatbot atau buka widget chatbot
      window.open('/chatbot', '_blank');
    } else if (channel.id === 'whatsapp') {
      // Redirect ke WhatsApp dengan nomor customer service
      const phoneNumber = '6287778882022'; // Ganti dengan nomor WhatsApp CS
      const message = encodeURIComponent('Halo, saya butuh bantuan customer service.');
      window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
    }
  };

  return (
    <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
      {channelOptions.map((channel) => (
        <div
          key={channel.id}
          className={`rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:scale-105
            ${isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-black'}`}
          onClick={() => handleChannelSelect(channel)}
        >
          {/* Icon */}
          <div className={`w-20 h-20 rounded-2xl bg-gradient-to-r ${channel.color} flex items-center justify-center mb-6 mx-auto`}>
            <img 
              src={channel.icon} 
              alt={channel.name}
              className="w-30 h-30 object-contain"
              onError={(e) => {
                e.target.style.display = 'none';
                const fallback = document.createElement('span');
                fallback.className = 'text-3xl';
                fallback.textContent = channel.fallbackIcon;
                e.target.parentNode.appendChild(fallback);
              }}
            />
          </div>

          {/* Content */}
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-3">{channel.name}</h3>
            <p className={`mb-6 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>{channel.description}</p>

            {/* Features */}
            <div className="mb-8">
              <ul className="space-y-2">
                {channel.features.map((feature, index) => (
                  <li key={index} className="flex items-center justify-center text-sm">
                    <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>

            {/* Action Button */}
            <button className={`w-full py-3 px-6 rounded-xl bg-gradient-to-r ${channel.color} hover:opacity-90 transition-opacity font-semibold text-white`}>
              {channel.action}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Channel;